import Vue from 'vue';
import App from './App.vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.less';
import router from '@/router/index';
import Print from 'vue-print-nb'
import Vant from "vant";
import "vant/lib/index.css";
// import VueI18n from 'vue-i18n'
import Element from 'element-ui'
// 防止dialog导致页面滚动条消失抖动
Element.Dialog.props.lockScroll.default = false;
import locale from 'element-ui/lib/locale/lang/en'
// import enLocale from 'element-ui/lib/locale/lang/en'
// import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import { axiosinstaller } from '@/request/request';
import ElFormRenderer from '@femessage/el-form-renderer'
import ElDataTable from '@femessage/el-data-table'
import config from './util/config'
import {MessageBox} from 'element-ui'
import './styles/element-variables.scss'
import VueClipBoard from 'vue-clipboard2'
import FBSignInButton from 'vue-facebook-signin-button'
import Cookies from "js-cookie";
// import vGoogleTranslate from "v-google-translate";
import i18n from '../public/languages/i18n'
import store from './store';
import moment from 'moment'
import qs from 'qs'
import directive from "@/directive";
import format from'vue-text-format';
import './assets/css/style.scss'
import global from '@/util/util'
import VueMarkdown from 'vue-markdown';
import hljs from 'highlight.js'
import 'highlight.js/styles/atom-one-dark.css' // 或其他你喜欢的主题
// Vue.use(vGoogleTranslate);
// 添加这段代码来正确配置 highlight.js
hljs.configure({
  languages: ['javascript', 'html', 'css', 'python', 'java', 'bash', 'json']
});
// 添加自定义指令以高亮代码
Vue.directive('highlight', {
  deep: true,
  bind(el) {
    const blocks = el.querySelectorAll('pre code');
    blocks.forEach(block => {
      hljs.highlightElement(block);
    });
  },
  componentUpdated(el) {
    const blocks = el.querySelectorAll('pre code');
    blocks.forEach(block => {
      hljs.highlightElement(block);
    });
  }
});
// 辅助函数，用于执行替换操作
function replacePlaceholders(el, binding, vnode) {
  // 确保函数在vue-markdown可能更新DOM之后运行
  Vue.nextTick(() => {
    const vm = vnode.context; // 指令所在的组件实例
    const placeholders = el.querySelectorAll('img-placeholder'); // 查找所有占位符
    
    // 收集所有图片URL用于预览列表
    const allImageUrls = Array.from(placeholders)
                             .map(p => p.getAttribute('data-src'))
                             .filter(src => !!src); // 过滤掉无效的src

    if (allImageUrls.length === 0) return; // 如果没有图片，则返回

    placeholders.forEach(placeholder => {
      const imgSrc = placeholder.getAttribute('data-src');
      if (!imgSrc) return; // 如果没有src，跳过

      // 创建一个div作为新Vue实例的挂载点
      const mountPoint = document.createElement('div');
      // 应用一个类以便样式化
      mountPoint.className = 'vue-component-mount-point'; 
      
      // 在DOM中用挂载点替换占位符
      if (placeholder.parentNode) {
        placeholder.parentNode.replaceChild(mountPoint, placeholder);
      } else {
        console.warn('替换时占位符没有父节点。');
        return; // 如果占位符已脱离DOM，则跳过
      }

      // 创建并挂载渲染el-image的Vue实例
      const instance = new Vue({
        parent: vm, // 从父组件(chatPanel)继承上下文
        render(h) {
          return h('div', { class: 'inline-image-container' }, [ // 外层包裹div
            h(Element.Image, { // 直接使用 Element.Image
              props: {
                src: imgSrc,
                previewSrcList: allImageUrls, // 提供所有URL用于预览
                // 计算正确的预览初始索引
                initialIndex: Math.max(0, allImageUrls.indexOf(imgSrc)), 
                zIndex: 3000, // 确保预览在最顶层
                fit: 'contain' // 根据需要调整fit模式
              },
              class: 'messages-picture-img' // 应用样式类
            }),
            // 下载按钮
            h('i', {
              class: 'el-icon-download image-download-icon', // 用于样式的类
              style: { /* 基本内联样式 */
                  cursor: 'pointer', marginLeft: '10px', color: 'white', fontSize: '20px', verticalAlign: 'middle' 
              },
              on: {
                click: (event) => {
                  event.stopPropagation(); // 防止触发图片预览
                  if (vm && typeof vm.getFile === 'function') {
                    vm.getFile(imgSrc,new Date().getTime()); // 调用父组件的方法
                  } else {
                    // 备用下载方法
                    const a = document.createElement('a');
                    a.href = imgSrc; a.download = imgSrc.split('/').pop() || 'image'; a.target = '_blank';
                    document.body.appendChild(a); a.click(); document.body.removeChild(a);
                  }
                }
              }
            })
          ]);
        }
      }).$mount(mountPoint); // 将实例挂载到创建的div上

      // 存储实例以便清理
      if (!el._imageInstances) {
        el._imageInstances = [];
      }
      el._imageInstances.push(instance);
    });
  });
}

// 定义指令
Vue.directive('replace-images', {
  bind(el, binding, vnode) {
    el._imageInstances = []; // 初始化实例存储
    replacePlaceholders(el, binding, vnode);
  },
  componentUpdated(el, binding, vnode) {
    // 在重新运行之前清理先前的实例
    if (el._imageInstances) {
      el._imageInstances.forEach(instance => instance.$destroy());
    }
    el._imageInstances = []; // 重置存储
    replacePlaceholders(el, binding, vnode); // 重新运行替换逻辑
  },
  unbind(el) {
    // 指令解绑时进行清理
    if (el._imageInstances) {
      el._imageInstances.forEach(instance => instance.$destroy());
    }
    delete el._imageInstances; // 移除存储属性
  }
});
// Vue.use(VueI18n)
// Vue.config.lang = 'en'
// Vue.locale('zh-cn', zhLocale)
// Vue.locale('en', enLocale)
Vue.prototype.$g = global;
Vue.prototype.$qs = qs
Vue.prototype.$cookies = Cookies;
Vue.prototype.$moment = moment;
Vue.use(FBSignInButton)
Vue.use(VueClipBoard)
Vue.use(format);
Vue.use(directive);
Vue.prototype.$confirmel = MessageBox.confirm;
Vue.use(config);
Vue.use(axiosinstaller);
Vue.prototype.$axios = axios;
Vue.use(Element, { locale })
Vue.use(Antd);
Vue.use(Vant);
Vue.use(Print);
// Vue.use(hljs)
Vue.component('el-form-renderer', ElFormRenderer)
Vue.component('el-data-table', ElDataTable)
Vue.component('VueMarkdown',VueMarkdown)
import echarts from 'echarts'

Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
axios.defaults.baseURL = '/api'

new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
  // el: '#app',
  created() {
    // this.checkLogin();
    // if (window.location.href.indexOf("login")>-1){
    //   this.$router.push({ path: "login" });
    // } else {
    //   this.$router.push({ path: "/backhome" });
    // }
    console.log(window.location.href)
    if (window.location.href.indexOf("?usercode=")>-1){
      let usercode=window.location.href.substring(32,48)
      console.log(usercode)
      if (usercode){
        this.$cookies.set("usercode",usercode)
      }
    }
    // 修改
    // this.$router.push({ path: "/backhome" });
    if ("ontouchstart" in document.documentElement) {
      this.$router.push({ path: "/phone" })
    } else {
      this.$router.push({ path: "/backhome" });
    }
    // let routerLink = sessionStorage.getItem("insideRouterLink");
    // if(routerLink=="insideLink"){
    //   if ("ontouchstart" in document.documentElement) {
    //     this.$router.push({ path: "/phone" });
    //   } else {
    //     this.$router.push({ path: "/backhome" });
    //   }
    // }

  },
  methods: {
    checkLogin: function () {
      window.console.log("---------main")
      let deadline = this.$cookies.get('deadline');
      let userInfo = this.$cookies.get("userInfo");
      let token = this.$cookies.get('token');
      let now = new Date().getTime();
      if(!deadline||!userInfo||!token) {
        // this.$router.push({ path: "login" });
        if ("ontouchstart" in document.documentElement) {
          this.$router.push({ name: "phonelogin" });
        } else {
          this.$router.push({ name: "login" });
        }
      }else{
        if (deadline<now){
          // this.$router.push({ path: "login" });
          if ("ontouchstart" in document.documentElement) {
            this.$router.push({ name: "phonelogin" });
          } else {
            this.$router.push({ name: "login" });
          }
        } else {
          this.$router.push({ path: "/backhome" });
        }
      }
    }
  }
}).$mount('#app')
